module.exports = __webpack_public_path__ + "static/media/two-kids-butter.9174dfe0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2017-11-4/two-kids-butter.jpg
// module id = 814
// module chunks = 0